import React from "react";

const TabContent = ({id, activeTab, children}) => {
    return (
        activeTab === id ? <div key={'tabContent' + id} className="tabContent">{ children }</div> : null
    );
};

export default TabContent;